export const delivery_type = {
  1: "Delivery",
  2: "Take Away",
  3: "Dine In",
};
